import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import H7 from 'UIComponents/elements/headings/H7';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DetailsPopoverBulletPoint({
  iconName,
  iconColor = CALYPSO_DARK,
  children
}) {
  return /*#__PURE__*/_jsx(UIMediaObject, {
    align: "baseline",
    itemLeft: /*#__PURE__*/_jsx(UIIcon, {
      name: iconName,
      size: 12,
      color: iconColor
    }),
    spacing: "extra-small",
    children: /*#__PURE__*/_jsx(H7, {
      "aria-level": 6,
      children: children
    })
  });
}